export default __webpack_public_path__ + "static/media/provider-icon4.ab43d82d.svg";